import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Rating from "@material-ui/lab/Rating";
import { Grid, Button, makeStyles } from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Divider from "@material-ui/core/Divider";
//FB 4498 BR:start update reviews for sessions
import { GetMessage, GetLink, updateReviews, GetPracticeName } from "../appointments/create/api/index"; // FB 4867
//FB 4498 BR:end update reviews for sessions
import Link from "@material-ui/core/Link";
//FB-6264
import { useHistory } from "react-router-dom";

// update log
// FB 4371 BR    03/29/2021    Appointment Reviews User Interface
// FB 4498 BR    06/10/2021    Review email for note creation
// FB 4653 BR    08/23/2021    PE - Text message changed in review emails
// FB 4867 BR    01/10/2022    PE - Implement the feature to upload Support files and Health forms after booking an appointment in PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR

const Reviews = (props: any) => {
  // alert(props.match.params.id);
  const [ratingValue, setRatingValue] = useState<number | null>(0);
  const [displayMessage, setDisplayMessage] = useState("none");
  const [displaylink, setDisplaylink] = useState("none");
  const [displayTextarea, setdisplayTextarea] = useState("none");
  const [displaySend, setDisoplaysend] = useState("none");
  const [displaySubmit, setDisoplaysubmit] = useState("flex");
  const [message, setMessage] = useState("");
  const [googlelink, setGoogleLink] = useState("");
  const [freezeStars, setfreezeStars] = useState(false);
  const [comments, setComments] = useState("");
  const [practiceName, setPracticeName] = useState(""); //FB 4867

  //FB 4867
  useEffect(() => {
    onload();
  }, []);

  //FB 4867
  const onload = async () => {
    const data = await GetPracticeName();
    setPracticeName(data);
  }

  const buttonClick = async () => {
    {/* FB 4639 BR - PE - Text message changed in review emails */ }
    const data = await GetMessage(ratingValue, props.match.params.id);
    setfreezeStars(true);
    setMessage(data);
    if (ratingValue !== null) {
      if (ratingValue <= 3) {
        setDisplayMessage("flex");
        setDisplaylink("none");
        setdisplayTextarea("flex");
        setDisoplaysend("flex");
        setDisoplaysubmit("none");
      }
      if (ratingValue >= 4) {
        //FB 4498 BR:start update reviews for sessions
        const data = await GetLink(props.match.params.id, props.match.params.flag);
        setGoogleLink(data);
        setDisplayMessage("none");
        setDisplaylink("flex");
        setdisplayTextarea("none");
        setDisoplaysend("none");
        setDisoplaysubmit("none");
        //FB 4498 BR:start update reviews for sessions
        //FB-6264
        updateReviews(ratingValue, comments, props.match.params.id);
        //FB 4498 BR:start update reviews for sessions
      }
      if (ratingValue == 0) {
        setDisplayMessage("none");
        setDisplaylink("none");
        setdisplayTextarea("none");
        setDisoplaysend("none");
      }
    } else {
      setDisplayMessage("none");
      setDisplaylink("none");
      if (ratingValue == 0) {
        setDisplayMessage("none");
        setDisplaylink("none");
      }
    }
  };

  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
  });

  const classes = useStyles();
  const history = useHistory();
  const sendButtonClick = () => {
    //update_appointment_reviews(props.match.params.id, ratingValue, comments); // FB 4867
    //FB 4498 BR:Start update reviews for sessions
    updateReviews(ratingValue, comments, props.match.params.id);
    //FB 4498 BR:End update reviews for sessions
    //FB 4867 BR:Added the missing parameter to navigate to thank you page
    history.push("/Thankyou/" + props.match.params.id);
  };

  return (
    <div>
      <section style={{ margin: "10px 10px 10px", height: "10" }}>
        <Grid container>
          <Grid
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h1 style={{ color: "gray" }}>Satisfaction Survey</h1>
          </Grid>
        </Grid>
        <Divider />
        <Grid container>
          <Grid
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <Box component="fieldset" mb={12} style={{display: "flex", alignItems: "center",justifyContent:"center"}} borderColor="transparent"> */}
            <Typography variant="h6" component="legend">
              {/* FB 4867 */}
              Please rate your recent visit at {practiceName}
            </Typography>
            {/* </Box> */}
          </Grid>
        </Grid>
        <br />
        <Grid container>
          <Grid
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Rating
              name="customized-empty"
              defaultValue={0}
              // precision={0.5}
              size="large"
              onChange={(event, newValue) => {
                setRatingValue(newValue);
              }}
              readOnly={freezeStars}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid
            item
            xs={6}
            sm={6}
            md={2}
            lg={2}
            style={{
              display: displaySubmit,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              className={classes.active}
              onClick={buttonClick}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        <br />
        <div style={{ display: displayTextarea }}>
          <Grid container>
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: displayMessage,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6">{message}</Typography>
            </Grid>
            <Grid
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TextareaAutosize
                aria-label="minimum height"
                style={{ width: "400px", borderColor: "gray" }}
                rowsMin={8}
                placeholder="Feedback"
                onChange={(e) => setComments(e.target.value)}
              />
            </Grid>
          </Grid>
        </div>

        <Grid container>
          <Grid
            lg={12}
            md={12}
            sm={12}
            xs={12}
            style={{
              display: displaylink,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* FB 4639 BR:Start - PE - Text message changed in review emails */}
            <p>
              <span>{message}</span>
              <span>
                <Link
                  style={{ fontSize: "20px" }}
                  href={googlelink}
                >
                  Click Here
                </Link>
              </span>

            </p>
            {/* FB 4639 BR:End - PE - Text message changed in review emails */}
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Grid
            item
            xs={6}
            sm={6}
            md={2}
            lg={2}
            style={{
              display: displaySend,
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              className={classes.active}
              onClick={sendButtonClick}
            >
              Send
            </Button>
          </Grid>
        </Grid>
      </section>
    </div>
  );
};

export default Reviews;
